



















































import { mapActions, mapMutations, mapState } from 'vuex';
import isEqual from 'lodash/isEqual';
import * as vr from '@/helpers/validation';

import { AxiosError } from 'axios';
import { errorToastMessage } from '@/helpers/errorToastMessage';
import { TOperatorWebhooksPayload } from '@/api/schema';
import {
  toggleWebhooksOperatorState,
  updateWebhookUrlsConfiguration
} from '@/api/CopyStake/OperatorWebhooks';

type TWebhooksSettingsData = {
  formValid: boolean;
  isSubmittingWebhookUrl: boolean;
  isSubmittingWebhookState: boolean;

  operatorWebhookState: boolean;
  values: TOperatorWebhooksPayload;
};

type TValidator = (v: string) => boolean | string;

export default {
  name: 'OnboardingWebhooksSettingsContent',
  data(): TWebhooksSettingsData {
    return {
      formValid: false,
      isSubmittingWebhookUrl: false,
      isSubmittingWebhookState: false,

      operatorWebhookState: false,
      values: {
        operatorWebhookUrlStartStream: '',
        operatorWebhookUrlEndStream: ''
      }
    };
  },
  computed: {
    ...mapState('Onboarding', ['operatorWebhooks', 'loading']),
    savedValues(): TOperatorWebhooksPayload {
      return {
        operatorWebhookUrlStartStream:
          this.operatorWebhooks.operatorWebhookUrlStartStream || null,
        operatorWebhookUrlEndStream:
          this.operatorWebhooks.operatorWebhookUrlEndStream || null
      };
    },
    validationRules(): {
      startUrl: TValidator[];
      endUrl: TValidator[];
    } {
      return {
        startUrl: this.operatorWebhookState
          ? [(v) => v === '' || v === null || vr.urlHttps(v)]
          : [],
        endUrl: this.operatorWebhookState
          ? [(v) => v === '' || v === null || vr.urlHttps(v)]
          : []
      };
    },
    isReadonly(): boolean {
      return (
        this.loading.operatorWebhooks ||
        this.isLoadingWebhookState ||
        this.isSubmittingWebhookUrl ||
        this.isSubmittingWebhookState
      );
    },
    isLoadingWebhookState(): boolean {
      return this.loading.operatorWebhooks || this.isSubmittingWebhookState;
    },
    isUrlUpdated(): boolean {
      return !isEqual(this.savedValues, this.values);
    },
    submitDisabled(): boolean {
      return (
        !this.operatorWebhookState ||
        !this.isUrlUpdated ||
        !this.formValid ||
        !this.values.operatorWebhookUrlStartStream ||
        !this.values.operatorWebhookUrlEndStream ||
        this.loading.operatorWebhooks
      );
    }
  },
  mounted(): void {
    this.getSavedSettings();
  },
  methods: {
    ...mapActions('Onboarding', ['getOperatorWebhooksData']),
    ...mapMutations('Onboarding', ['setOperatorWebhooksData']),
    getSavedSettings(): void {
      this.getOperatorWebhooksData()
        .then(() => {
          this.parseWebhooksDataFromStore();
        })
        .catch((err: AxiosError) => {
          errorToastMessage(err);
        });
    },
    updateSettings(): void {
      if (this.isSubmittingWebhookUrl) return;

      this.isSubmittingWebhookUrl = true;

      updateWebhookUrlsConfiguration(this.values)
        .then((data) => {
          this.setOperatorWebhooksData(data);
          this.parseWebhooksDataFromStore();

          this.$toast.success('Webhooks URLs updated.');
        })
        .catch(() => {
          this.$toast.error('Webhooks URLs update failed.');
          this.getSavedSettings();
        })
        .finally(() => {
          this.isSubmittingWebhookUrl = false;
        });
    },
    handlerChangeWebhookStateSwitch(state: boolean): void {
      this.isSubmittingWebhookState = true;

      toggleWebhooksOperatorState(state)
        .then((data) => {
          this.setOperatorWebhooksData(data);
          this.parseWebhooksDataFromStore();
        })
        .catch((err: AxiosError) => {
          errorToastMessage(err);
          this.getSavedSettings();
        })
        .finally(() => {
          this.isSubmittingWebhookState = false;
        });
    },
    parseWebhooksDataFromStore(): void {
      this.values.operatorWebhookUrlStartStream =
        this.operatorWebhooks.operatorWebhookUrlStartStream || null;
      this.values.operatorWebhookUrlEndStream =
        this.operatorWebhooks.operatorWebhookUrlEndStream || null;

      this.operatorWebhookState =
        this.operatorWebhooks.operatorWebhookEnabled || false;
    }
  }
};
